module.exports = __webpack_public_path__ + "static/seo-2.6b5b70df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/seo/seo-2.svg
// module id = 44
// module chunks = 168707334958949